<template>
  <AtomsTextLink :href="props.url" class="vendor">
    <div class="vendor__logo" :style="`background-image: url('${useShopZone().value.staticResourcesRoot}/img/groups/vendors1/${props.groupId}.png');`"></div>
    <span class="vendor__name">{{ name }}</span>
    <img class="vendor__flag" v-if="props.flag" :src="`/img/flags/${props.flag.toLowerCase()}.svg`" :alt="props.flag" />
  </AtomsTextLink>
</template>
<script setup>

const props = defineProps({
  url: String,
  groupId: Number,
  name: String,
  flag: String
});

const appConfig = useAppConfig();

</script>
<style lang="postcss">
.vendor {
  @apply flex flex-col w-[150px] justify-center gap-4 p-2 text-sm text-center text-secondary-500 border border-secondary-500 hover:no-underline;

  &__logo {
    @apply aspect-video bg-center bg-no-repeat transition-all;

    filter: grayscale(100%);

  }

  &:hover &__logo {
    filter: grayscale(0%);
  }

  &__name {
    @apply flex flex-1 items-center justify-center;
  }

  &__flag {
    @apply w-6 mx-auto mb-2 border border-secondary-500 rounded-md;
  }
}
</style>